export default {
  fristTitle: 'Aftersale Detail',
  secondTitle: 'After Sales Information',
  description: 'Description',
  appealInfo: '申诉信息',
  isAppeal: '是否申诉',
  appealTime: '申诉时间',
  complainant: '申诉方',
  appealDesc: '申诉说明',
  information: 'Payment Information',
  statistics: 'User Order Statistics',
  review: '审核区域',
  solution: 'Solution',
  deliveryCharge: 'Who pay delivery charge',
  seller: 'Seller',
  user: 'User',
  refundAmount: 'Refund amount',
  reject: 'Reject',
  currentStatus: 'Current status',
  postageBurden1: 'Platform',
  postageBurden2: 'Seller',
  postageBurden3: 'User',
  deliveryStatus1: '新创建',
  deliveryStatus2: '待收货',
  deliveryStatus3: '待检验',
  deliveryStatus4: 'Pickup completed',
  deliveryStatus5: '验货失败',
  afterSaleMethodMap1: 'Exchange',
  afterSaleMethodMap2: 'Return and refund',
  afterSaleMethodMap3: 'Repair',
  afterSaleMethodMap4: 'Only refund',
  afterSaleMethodMap5: 'Resend',
  nextOperateMap1: 'no',
  nextOperateMap2: 'returnOrder',
  nextOperateMap3: 'repair',
  nextOperateMap4: 'delivery',
  nextOperateMap5: 'Refund',
  reason1: 'Quality Problem',
  reason2: '送达时损坏',
  reason3: '货不对版',
  origin1: 'App',
  origin2: 'Wap',
  origin3: 'Email',
  origin4: 'Facebook',
  initiator1: 'Admin',
  initiator2: 'User',
  standard1: '可二次销售',
  standard2: '维修要求',
  standard3: 'Not manmade quality problem',
  refundMethod1: '原路退回',
  refundMethod2: 'bkash',
  refundMethod3: '银行卡',
  refundMethod4: '退为无门槛长期券',
  paymentMethodMap1: 'Online',
  paymentMethodMap2: 'COD',
  paymentMethodMap3: 'Pre',
  disposeList1: 'Exchange',
  disposeList2: 'Repair',
  disposeList3: 'Return and refund',
  disposeList4: 'Only refund',
  disposeList5: 'Resend',
  sellerList1: '卖家审核通过',
  sellerList2: '卖家审核拒绝',
  salesList1: '平台审核通过',
  salesList2: '平台审核拒绝',
  newSaleColumns1: 'Source',
  newSaleColumns2: 'FB name, phone, email address',
  newSaleColumns3: 'Aftersale reason',
  newSaleColumns4: 'Product payment',
  newSaleColumns5: 'VAT',
  newSaleColumns6: 'Solution',
  newSaleColumns7: 'Who pay delivery charge',
  newSaleColumns8: 'Who apply',
  newSaleColumns9: 'System ID',
  newSaleColumns10: 'SKU ID',
  newSaleColumns11: 'Quantity',
  UserTransactionColumns1: 'Total order',
  UserTransactionColumns2: 'Successful Order',
  UserTransactionColumns3: 'Rejected Order',
  UserTransactionColumns4: 'Aftersale Case',
  UserTransactionColumns5: 'Aftersale SO',
  saleReturnColumns1: 'Return order ID',
  saleReturnColumns2: 'User ID',
  saleReturnColumns3: 'Created Time',
  saleReturnColumns4: 'Aftersale application ID',
  saleReturnColumns5: 'Original SO number',
  saleReturnColumns6: 'SKU ID',
  saleReturnColumns7: 'Quantity',
  saleReturnColumns8: 'Receipt standard',
  saleReturnColumns9: 'Status',
  saleReturnColumns10: 'Follow-up work ticket',
  saleReturnColumns11: 'Aftersale method',
  saleReturnColumns12: 'Recipient ID',
  saleReturnColumns13: 'Quality inspector ID',
  deliveryOrderColumns1: 'DeliveryOrder ID',
  deliveryOrderColumns2: 'User ID',
  deliveryOrderColumns3: 'Created Time',
  deliveryOrderColumns4: 'Aftersale application ID',
  deliveryOrderColumns5: 'Original SO number',
  deliveryOrderColumns6: 'SKU ID',
  deliveryOrderColumns7: 'Quantity',
  deliveryOrderColumns8: 'Status',
  deliveryOrderColumns9: 'Follow-up work ticket',
  deliveryOrderColumns10: 'Aftersale method',
  deliveryOrderColumns11: '工单处理人',
  deliveryOrderColumns12: '尾程物流单号',
  inner1: '新创建',
  inner2: '待发货',
  inner3: '已发货',
  inner4: '派送中',
  inner5: '已送达',
  repairOrderColumns1: 'RepairOrder ID',
  repairOrderColumns2: 'User ID',
  repairOrderColumns3: 'Created Time',
  repairOrderColumns4: 'Aftersale application ID',
  repairOrderColumns5: 'Original SO number',
  repairOrderColumns6: 'SKU ID',
  repairOrderColumns7: 'Quantity',
  repairOrderColumns8: 'Sku Title',
  repairOrderColumns9: 'Status',
  repairOrderColumns10: 'Follow-up work ticket',
  repairOrderColumns11: 'Aftersale method',
  repairOrderColumns12: '维修人员',
  innerstandard1: '新创建',
  innerstandard2: '待处理',
  innerstandard3: '维修中',
  innerstandard4: '已修复',
  innerstandard5: '无法修复',
  refundColumns1: 'Refund Ticket ID',
  refundColumns2: 'User ID',
  refundColumns3: 'Created Time',
  refundColumns4: 'Aftersale application ID',
  refundColumns5: '支付方式',
  refundColumns6: '原SO单号',
  refundColumns7: 'SKU ID',
  refundColumns8: 'Quantity',
  refundColumns9: '退款额',
  refundColumns10: 'Status',
  refundColumns11: 'Aftersale method',
  refundColumns12: 'Financial reviewer',
  refundColumns13: 'Refunder',
  refundColumns14: 'Refund path',
  innerstandard_pay1: '待审核',
  innerstandard_pay2: '待退款',
  innerstandard_pay3: '退款中',
  innerstandard_pay4: '退款完成',
  InformationColumns1: 'SO#',
  InformationColumns2: 'Order payment',
  InformationColumns3: 'Delivery Charge',
  InformationColumns4: 'VAT',
  error1: '退款金额不得大于订单实付金额',
  error2: '请选择运费承担',
  success1: '请选择处理方式',
  // ---------------------------------2021/3/9新增------------
  talkInfo: 'Talk with the customer',
  passed: 'Are you sure to passed',
  rejected: 'Are you sure to reject',
  // -----------system-notify----------------------------------
  sn_pageTitle: 'Platform Notifications',
  sn_clearAll: 'Clear All',
  sn_metaTitle: 'System Notify',
  sn_notificationColumns1: 'id',
  sn_notificationColumns2: 'Time',
  sn_notificationColumns3: 'Type',
  sn_notificationColumns4: 'Content',
  sn_notificationColumns5: 'Operation',
  sn_confirm1: 'Order',
  sn_confirm2: 'Aftersales',
  sn_read: 'Set Read',
  sn_srueClear: '您确定要清除这些消息吗',
  express_account: 'XED物流帐号'
}
